export const TABLELIST_BUTTON_COLOR_1 = "#388F00"; // Lime
export const TABLELIST_BUTTON_COLOR_2 = "#FFFFFF"; // White
export const TABLELIST_BUTTON_COLOR_3 = "#b4b8da"; // Light purple
export const TABLELIST_BUTTON_COLOR_4 = "#0f623f"; // Dark green
export const TABLELIST_BUTTON_COLOR_5 = "#2C3B48"; // Jeans
export const TABLELIST_BUTTON_COLOR_6 = "#B5A72A"; // Gold
export const TABLELIST_BUTTON_COLOR_7 = "#1D2668"; // Dark blue
export const TABLELIST_BUTTON_COLOR_8 = "#B52F2A"; // Dark red
export const TABLELIST_BUTTON_COLOR_9 = "#0f623f"; // Dark green (??)

export const TABLELIST_BUTTON_ICON_CLASS_VIEW = "fa fa-eye";
export const TABLELIST_BUTTON_ICON_CLASS_EDIT = "fa fa-cog";
export const TABLELIST_BUTTON_ICON_CLASS_TIMES = "fa fa-times";
export const TABLELIST_BUTTON_ICON_CLASS_DELETE = "fa fa-remove";
export const TABLELIST_BUTTON_ICON_CLASS_CLONE = "fas fa-copy";
